// This allows us to whitelist some classes that are used in concatenation or interpolation in our code
// base, and that would otherwise be purged. Doc: https://purgecss.com/configuration.html#configuration-file

const purgeCssWhitelistedClasses = [
  'border-green-200',
  'text-green-200',
  'shadow-highlight',
  'border-l-current',
  'border-r-current',
  'border-b-current',
  'border-t-current',
  'border-8',
  'absolute',
  'block',
  'border-transparent',
  'border-r-0',
  'border-l-12',
  'border-r-12',
  'border-b-12',
  'border-t-12',
  'top-1/2',
  'left-1/2',
  '-right-4',
  '-ml-4',
  '-mb-4',
  'border-l-0',
  'bottom-0',
  'border-b-0',
  'shadow-md',
  'm-3',
  'font-normal',
  'list-disc', 
  'space-y-3',
];

module.exports = purgeCssWhitelistedClasses;
